import { Controller } from "@hotwired/stimulus"
import { Collapse } from "bootstrap"

// Select-box style engraving toggle: the header checkbox opens a panel with
// both the font select and the text input. Closing clears both fields so a
// dismissed engraving never submits with the cart.
export default class extends Controller {
  static targets = ["checkbox", "panel", "fontSelect", "textInput"]

  connect() {
    this.collapse = new Collapse(this.panelTarget, { toggle: false })
  }

  disconnect() {
    this.collapse?.dispose()
    this.collapse = null
  }

  toggleEngraving() {
    const open = this.checkboxTarget.checked

    if (open) {
      this.collapse.show()
    } else {
      this.collapse.hide()
      this.fontSelectTarget.value = ""
      this.clearText()
      this.textInputTarget.disabled = true
    }

    this.element.classList.toggle("open", open)
    this.checkboxTarget.setAttribute("aria-expanded", String(open))
  }

  fontChanged() {
    const fontSelected = this.fontSelectTarget.value !== ""

    this.textInputTarget.disabled = !fontSelected
    if (!fontSelected) {
      this.clearText()
    } else {
      this.textInputTarget.focus()
    }
  }

  // Assigning .value doesn't fire `input`, so the text-counter would keep
  // showing the remaining count from the cleared message.
  clearText() {
    this.textInputTarget.value = ""
    this.textInputTarget.dispatchEvent(new Event("input", { bubbles: true }))
  }

  preventEnter(event) {
    if (event.key === "Enter" || event.keyCode === 13) {
      event.preventDefault()
      return false
    }
  }
}
